import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {fetchPartners} from '../../services/partners';
import EditButton from '../../svgs/EditButton';

const limit = 10
function Page(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo=(str)=>()=>{
        navigate(str)
    }

    const [partners, setPartners] = useState([])
    async function fetchData(){
        const filter = {}
        const res = await fetchPartners(filter, {limit,skip:0,sort:{order:-1}})
        if(res.errno) return
        setPartners(res.result)
    }
    useEffect(()=>{
        fetchData()
    },[])
   

    return(
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] p-[16px]" style={{overflow:'auto'}}>
            
            {/* <div className="text-[#6E604C] text-[24px] font-bold w-full text-left">
                歡迎回來, {props.token.username}
            </div> */}
            <img src='/cms/home.png' style={{width:'100%',objectFit:'contain'}}/>
            <div className="flex flex-row w-full gap-[16px] p-[16px] flex-wrap">
                {partners.map((item,index)=>{
                    return(
                        <div key={index} className="w-[400px] relative border-[1px] border-[white] gap-[6px] rounded-[24px] flex justify-start items-center flex-col bg-[#ffffff40]" style={{height:undefined,aspectRatio:1,overflow:'hidden'}}>
                            <div className="absolute top-0 left-0 right-0 bottom-0 z-[1]" style={{background: 'linear-gradient(180deg, rgba(230, 235, 237, 0.3) 28.5%, #FFFFFF 100%)'}}/>
                            {item?.thumbnail?
                                <img src={item?.thumbnail} className="rounded-[16px] z-[2]" style={{width:'100%',objectFit:'cover'}}/>
                                :<div/>
                            }
                            <div className="text-[20px] font-[700] mt-[24px] z-[2]">{item?.name}</div>
                            <div onClick={navigateTo(`/cms/partners/${item._id}`)} className="cursor-pointer hover:opacity-80 mt-[24px] z-[2]">
                                <EditButton/>
                            </div>
                            
                        </div>
                    )
                })}
            </div> 
        </div>
    )
}


export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Page)


